import type { CustomThemeConfig } from "tailwindcss/types/config";

export const extend: Partial<CustomThemeConfig> = {
	colors: {
		primary: {
			50: "rgb(var(--color-primary-50))",
			100: "rgb(var(--color-primary-100))",
			200: "rgb(var(--color-primary-200))",
			300: "rgb(var(--color-primary-300))",
			400: "rgb(var(--color-primary-400))",
			500: "rgb(var(--color-primary-500))",
			600: "rgb(var(--color-primary-600))",
			700: "rgb(var(--color-primary-700))",
			800: "rgb(var(--color-primary-800))",
			900: "rgb(var(--color-primary-900))",
			1000: "rgb(var(--color-primary-1000))",
		},
		"primary-accent": {
			50: "rgb(var(--color-primary-accent-50))",
			100: "rgb(var(--color-primary-accent-100))",
			200: "rgb(var(--color-primary-accent-200))",
			300: "rgb(var(--color-primary-accent-300))",
			400: "rgb(var(--color-primary-accent-400))",
			500: "rgb(var(--color-primary-accent-500))",
			600: "rgb(var(--color-primary-accent-600))",
			700: "rgb(var(--color-primary-accent-700))",
			800: "rgb(var(--color-primary-accent-800))",
			900: "rgb(var(--color-primary-accent-900))",
			1000: "rgb(var(--color-primary-accent-100))",
		},
		secondary: {
			50: "rgb(var(--color-secondary-50))",
			100: "rgb(var(--color-secondary-100))",
			200: "rgb(var(--color-secondary-200))",
			300: "rgb(var(--color-secondary-300))",
			400: "rgb(var(--color-secondary-400))",
			500: "rgb(var(--color-secondary-500))",
			600: "rgb(var(--color-secondary-600))",
			700: "rgb(var(--color-secondary-700))",
			800: "rgb(var(--color-secondary-800))",
			900: "rgb(var(--color-secondary-900))",
			1000: "rgb(var(--color-secondary-1000))",
		},
		"secondary-accent": {
			50: "rgb(var(--color-secondary-accent-50))",
			100: "rgb(var(--color-secondary-accent-100))",
			200: "rgb(var(--color-secondary-accent-200))",
			300: "rgb(var(--color-secondary-accent-300))",
			400: "rgb(var(--color-secondary-accent-400))",
			500: "rgb(var(--color-secondary-accent-500))",
			600: "rgb(var(--color-secondary-accent-600))",
			700: "rgb(var(--color-secondary-accent-700))",
			800: "rgb(var(--color-secondary-accent-800))",
			900: "rgb(var(--color-secondary-accent-900))",
			1000: "rgb(var(--color-secondary-accent-1000))",
		},
	},
	fontFamily: {
		montserrat: ["var(--font-montserrat)", "sans-serif"],
		oxygen: ["var(--font-oxygen)", "sans-serif"],
	},
};
